import React, { useState, useEffect } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material UI
import Box from '@material-ui/core/Box';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// Material Icons
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

// Types
import { EmtuReportDataInterface } from 'store/ducks/reports/types';
import { ApplicationState } from 'store';

// Components
import SubRow from './components/SubRow/SubRow';

// styles
import useStyles from './Row.styles';

interface RowProps {
  report: EmtuReportDataInterface;
  index: number;
  openCollapseAll: boolean;
}

const Row: React.FC<RowProps> = ({ report, index, openCollapseAll }) => {
  const classes = useStyles();

  const [openCollapse, setOpenCollapse] = useState(false);

  const classRow = index % 2 === 0 ? classes.evenRow : classes.oddRow;
  const collapseClassRow =
    index % 2 === 0 ? classes.collapseEvenRow : classes.collapseOddRow;

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );

  useEffect(() => {
    setOpenCollapse(openCollapseAll);
  }, [openCollapseAll]);

  return (
    <>
      <TableRow className={classRow}>
        <TableCell className={classes.tdName}>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'>
            <Typography className={classes.userName}>{report.user}</Typography>
          </Box>
        </TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
        {transportOperatorSelected.type === 1 && (
          <TableCell>
            {transportOperatorsList.find(
              (e) => e.id === report?.transportOperatorId,
            )?.name || '---'}
          </TableCell>
        )}
        <TableCell>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'>
            <Box display='flex' alignItems='center'>
              <IconButton
                aria-label='expand row'
                size='small'
                onClick={() => setOpenCollapse((o) => !o)}>
                {openCollapse ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
      {openCollapse && (
        <SubRow
          balance={report.balance}
          monthsResult={report.monthsResult}
          collapseClassRow={collapseClassRow}
        />
      )}
    </>
  );
};

export { Row };
export default Row;
